import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Img from "react-cool-img";
import mime from 'mime';
import { useTranslation } from 'react-i18next/hooks';
import Linkify from 'react-linkify';

import Button from '../../../../Button/Button';
import TransBackdrop from '../../../../Backdrop/TransBackdrop';
import SmallModal from '../../../../Modal/SmallModal';
import GroupTextNameIcons from '../GroupTextNameIcons';

import { useStore } from '../../../../../hook-store/store';
import { getDateTime } from '../../../../../util/timeFormat';
import { scrollToTextListRefItem } from '../../../../../util/group/group-text-list';
// import { isImageFile, isVideoFile, isAudioFile } from '../../../../util/image';

import { marks } from '../../../../../images/marks';
import classes from './GroupTextItemReplyOri.module.css';

import SampleImage from "../../../../Image/person-icon-50.jpg";

const GroupTextItemReplyOriDetail = (props) => {
  // console.log('GroupTalkTextItem-props', props);
  const { 
    inputData, 
    showReplyOriModal,
    setShowReplyOriModal,
    replyOriInputData,
    replyOriNameData,
    fileMime,
    lsNameDataList,
   } = props;


  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const {
    selectedGroupData,
    groupTextItemRef,
  } = store.groupStore;
  // console.log('store in GroupTalkTextItem', store);

  const [replyTexts, setReplyTexts] = useState([]);
  console.log('replyTexts', replyTexts);

  useEffect(() => {
    if (selectedGroupData && selectedGroupData.talks && selectedGroupData.talks.length > 0) {
      
      const replyItems = [];
      
      for (const text of selectedGroupData.talks) {
        const replyInfo = text.replyInfo;

        if (replyInfo && replyInfo.originalTextId === replyOriInputData._id) {
          // console.log(replyInfo.originalTextId, inputData._id)
          replyItems.push(text);
        }

        if (replyItems.length > 0) {
          setReplyTexts(replyItems);
        }
      }
    }
  },[selectedGroupData]);
  
  const componentDecorator = (href, text, key) => (
    <a href={href} key={key} target="_blank" rel="noopener noreferrer" style={{color: 'gray', fontWeight: ''}}>
        {text}
    </a>
  );

  const scrollToOriTextHandler = () => {
    const isScrolled = scrollToTextListRefItem(
                          groupTextItemRef,
                          replyOriInputData._id
                        );
    
    if (isScrolled) {
      const scrolledMessge = (
        <div>
          <span
            onClick={() => {
              scrollToTextListRefItem(
                  groupTextItemRef,
                  inputData._id
                );
              dispatch('CLEAR_NOTIFICATION');
            }}
          >
            {t('groupTalk.text107', 'Back to post')}
          </span>
        </div>
      );

      dispatch('SHOW_NOTIFICATION', {
        status: '',
        // title: 'scrolled to item',
        title: scrolledMessge,
        message: '',
      });

    } else {

      if (selectedGroupData && selectedGroupData.talks && selectedGroupData.talks.length > 0) {
        const targetIdx = selectedGroupData.talks.findIndex(ele => {
          return ele._id === replyOriInputData._id;
        });

        // const failData = {
        //   targetTalkIdx: targetIdx,
        // };

        // console.log('failData', failData, );

        // dispatch('SET_GROUPPOSTSCROLLFAILDATA', failData);
      
        if (targetIdx > -1) {
          const postTime = getDateTime(replyOriInputData.sendAt);
          const fmessage = (<span>Time: {postTime}</span>)
          
          dispatch('SHOW_NOTIFICATION', {
            status: '',
            title: 'Selected post is older than displaying posts. Scroll up more to display older posts.',
            message: fmessage,
          });

          setTimeout(() => {
            dispatch('CLEAR_NOTIFICATION');
          }, 1000*10);
        }
      }
    }
  };








  // let replyOriInputData;
  // let replyOriNameData;

  // if (inputData && inputData.replyInfo && inputData.replyInfo.originalTextId &&
  //   selectedGroupData
  // ) {
  //   replyOriInputData = selectedGroupData.talks?.find(element => {
  //     return element._id === inputData.replyInfo.originalTextId;
  //   });

  //   if (replyOriInputData && lsNameDataList && JSON.parse(lsNameDataList).length > 0) {
  //       replyOriNameData = JSON.parse(lsNameDataList).find(ele => {
  //         return ele.userId === replyOriInputData.fromUserId;
  //       });
  //   }
  //   // console.log('replyOriginalData', replyOriInputData)
  //   // console.log('replyOriNameData', replyOriNameData)
  // }


  // let fileMime;

  // if (replyOriInputData && replyOriInputData.filePaths && replyOriInputData.filePaths.length > 0) {
  //   fileMime = mime.getType(replyOriInputData.filePaths[0]);
  //   // console.log(fileMime)
  //   // if (fileMime && fileMime.split('/')[0] === 'audio') {
  //   //   oriFileContent = (
  //   //     <span>{marks.fileAudio}</span>
  //   //   )

  // }

  // if (replyOriInputData && replyOriInputData.kuraFileInfo && replyOriInputData.kuraFileInfo.mimeType) {
  //   fileMime = replyOriInputData.kuraFileInfo.mimeType;
  // }



  let replyOriModalBody;

  if (showReplyOriModal) { 
    replyOriModalBody = (
      <div>
        <TransBackdrop onClick={() => {
            setShowReplyOriModal(false);
          }} 
        />
        <SmallModal 
          // style={classes.groupTalkTextItemConfirmModal}
        >
          <div>
            <div className={classes.groupTextItemReplyOriModalClose}>
              <span
                onClick={() => {
                  setShowReplyOriModal(false);
                }}
              >
                X
              </span>
            </div>
            <div>
              <div className={classes.groupTextItemReplyOriRow}>
                <div className={classes.groupTextItemReplyOriModalContent}>
                  {replyOriInputData && (
                    <div className={classes.groupTextItemReplyOriRow}>
                      <div className={classes.groupTextItemReplyOriModalText}>
                        <Linkify componentDecorator={componentDecorator}>
                          {replyOriInputData.text}
                        </Linkify>
                        {' '}
                        {fileMime && (
                          <span>{marks.fileMark}</span>
                        )}
                      </div>
                    </div>
                  )}

                  {replyOriNameData && (
                    <div className={classes.groupTextItemReplyOriModalUser}>
                      {replyOriNameData.name}
                      {replyOriNameData.imageUrl && (
                        <Img style={{height: "1.25rem", width:"1.25rem", objectFit: "cover"}}
                          src={replyOriNameData.imageUrl}
                        />
                      )}
                      {!replyOriNameData.imageUrl && (
                        <Img style={{height: "1.25rem", width:"1.25rem", objectFit: "cover"}}
                          src={SampleImage}
                        />
                      )}
                    </div>
                  )}

                  {replyOriInputData && (
                    <div className={classes.groupTextItemReplyOriModalTime}
                    >
                      {getDateTime(replyOriInputData.sendAt)}
                    </div>
                  )}

                  {replyTexts.length > 0 && (
                    <div className={classes.groupTextItemReplyOriModalReply}>
                      <span>
                        {replyTexts.length} {t("groupTalk.text108","reply messages to this post")}
                      </span>
                      <span>
                        <GroupTextNameIcons 
                          lsNameDataList={lsNameDataList}
                          textList={replyTexts}
                          size={1}
                          limit={3}
                        />
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <div className={classes.groupTextItemReplyOriModalButton}>
                <Button mode="" type="" size="smaller"
                  onClick={() => {
                    setShowReplyOriModal(false);
                    scrollToOriTextHandler();
                  }}
                >
                  {t('groupTalk.text106', 'Go to post')}
                </Button>
              </div>
            </div>
          </div>
        </SmallModal>
      </div>
    )
  }


  return (
    <Fragment>

      <div>
        {replyOriModalBody}
      </div>
    </Fragment>
  );
}

export default GroupTextItemReplyOriDetail;